<script lang="tsx">
  import { defineComponent } from 'vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import BeerIcon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import { PLUS_PATH } from '@xhs/yam-beer/cmp/constants/builtinIcon'

  export default defineComponent({
    name: 'NewImpage',
    components: {
      BeerIcon,
      NewBsBox,
    },
    props: {
      bs: {
        type: Object,
        default: () => ({}),
      },
      btnName: {
        type: String,
        default: '上传图片',
      },
      disabled: {
        type: Boolean,
      },
    },

    setup(props, { slots }) {
      return () => (
        <NewBsBox
          bs={{
            'cmp.imageUpload': 'card',
            'cmp.imageUpload.cardState': 'default',
            ...props.bs,
          }}
          // @ts-ignore
          disabled={props.disabled || undefined}
        >
          <NewBsBox
            bs={{
              'cmp.imageUpload': 'box',
              'cmp.imageUpload.boxVariant': 'new',
            }}
            data-slot="box"
          >
            <BeerIcon
              iconPath={PLUS_PATH}
              size={24}
              gridSize={24}
              color="mute"
            />
          </NewBsBox>

          {slots.btnText ? slots.btnText() : (
            <NewBsBox
              bs={{
                'cmp.imageUpload': 'fileName',
              }}
              data-slot="filename"
            >
              {props.btnName}
            </NewBsBox>
          )}
        </NewBsBox>
    )
    },
  })
</script>
